import React from "react";
import { TableRow, TableCell, Typography } from "@mui/material";
import { PriceModel } from "./data/PriceModel";
import { styled } from "@mui/system";

interface RegionRowProps {
  priceData: PriceModel[];
}

const CustomTableCell = styled(TableCell)({
  padding: '9px', // Adjust the padding as needed
});

/**
 * Component that renders a table row with Country information for each `PriceModel` item.
 *
 * @param {RegionRowProps} props - The props for the component.
 * @param {PriceModel[]} props.priceData - The array of `PriceModel` objects containing the data to display.
 * @returns {React.ReactElement} - A `TableRow` element containing table cells with unit information.
 */
const RegionRow: React.FC<RegionRowProps> = ({
  priceData,
}: RegionRowProps): React.ReactElement => (
  <TableRow>
    <CustomTableCell>Country</CustomTableCell>
    {priceData.map((item) => (
      <CustomTableCell key={item.id}>
         <Typography variant="body2">
          {
            (item.country ? `${item.country}` : "") 
          }
        </Typography>
        
      </CustomTableCell>
    ))}
  </TableRow>
);

export default RegionRow;